import type { UserOptions } from "../../components/options/optionsTypes";
import { LocalStorageKey } from "../localStorage";
import type { DefaultedRemoteAdminSettings, LocalStoredSettings } from "./types";

/**
 * Default user options.
 *
 * Only includes keys that are admin-controlled.
 */
export const DEFAULT_USER_SETTINGS: Pick<
  UserOptions,
  "ntpEnabled" | "rovoCompanionEnabled" | "gdocsDefinitionsEnabled"
> = {
  ntpEnabled: true,
  rovoCompanionEnabled: true,
  gdocsDefinitionsEnabled: true,
};

/**
 * Default chrome stored settings (chrome.storage-backed UserOptions).
 */
export const DEFAULT_CHROME_STORED_SETTINGS: UserOptions = {
  ntpEnabled: true,
  topSitesEnabled: true, // A.K.A "Custom links"
  rovoCompanionEnabled: true,
  gdocsDefinitionsEnabled: true,
};

/**
 * Default remote admin settings (used when remote admin settings have not loaded).
 */
export const DEFAULT_REMOTE_ADMIN_SETTINGS: DefaultedRemoteAdminSettings = {
  controlledUserNtpEnabled: true,
  controlledUserRovoCompanionEnabled: true,
  controlledUserGdocsDefinitionsEnabled: true,
  controlledUserDomContentEnabled: true,
  controlledUserCompanyAnnouncements: true,
};

/**
 * Default local (user) settings (used when SettingsContext is not enabled).
 */
export const DEFAULT_LOCAL_STORED_SETTINGS: LocalStoredSettings = {
  [LocalStorageKey.WELCOME_HEADER_ENABLED]: true,
  [LocalStorageKey.GLOBAL_CREATE_ENABLED]: true,
  [LocalStorageKey.LOCAL_DEV_BANNER_ENABLED]: true,
  [LocalStorageKey.CALENDAR_ENABLED]: false,
  [LocalStorageKey.RECENT_WORK_ENABLED]: true,
  [LocalStorageKey.BOOKMARKS_ENABLED]: true,
  [LocalStorageKey.ANNOUNCEMENTS_ENABLED]: true,
};
